import 'lazysizes'

document.addEventListener('lazybeforeunveil', function(e) {
  const { target } = e
  const bg = target.getAttribute('data-src')
  if (bg && target.tagName != 'IMG') {
    e.target.style.backgroundImage = 'url(' + bg + ')'
  }
})
